export enum WithdrawalDialogs {
  FEE_SELECTORS = 'FEE_SELECTORS',
  WITHDRAW_VERIFICATION = 'WITHDRAW_VERIFICATION',
  USER_VERIFICATION = 'USER_VERIFICATION',
  RATE_DIALOG = 'RATE_DIALOG',
}
